import { Component, viewChild, ElementRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-validate-code-dialog',
  standalone: false,
  templateUrl: './validate-code-dialog.component.html',
  styleUrl: './validate-code-dialog.component.scss',
})
export class ValidateCodeDialogComponent {
	private alertDesc = viewChild<ElementRef<HTMLDivElement>>('alertDesc');
	ui: any = {}
	isInvalid = false;
	constructor(
		public dialogRef: MatDialogRef<ValidateCodeDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		const val: string = ''
		this.ui = {
			connectOptions: {
				...{
					type: 'code',
					minLength: 4,
					maxLength: 4,
					showApply: false,
					showValue: false,
					amount: val,
					amountText: val,
					title: 'OAT.validate_last4_title',
					desc: 'OAT.validate_last4_desc',
				}, ...this.data.connectOptions
			},
			connectValue: val,
			connectValid: false,
			authValue: '',
			authValid: false
		}
	}

	onKeypadChange(val) {
		if (!val) return;
		let n = val.amountText.length;
		this.ui.connectValue = val.amountText;
		this.ui.connectValid = this.ui.connectValue.length >= 1;
	}

	close() {
		this.dialogRef.close();
	}
	apply() {
		const alertDesc = this.alertDesc()?.nativeElement;

		alertDesc.classList.remove('animated', 'shake', 'fast');
		setTimeout(() => {
			alertDesc.classList.add('animated', 'shake', 'fast');
		});

		if (this.ui.connectValue !== this.data.secret) {
			this.isInvalid = true;
			return;
		}
		this.isInvalid = false;
		this.dialogRef.close({});
	}

}
